import { IFormConfig } from 'js/components/common/ChangeForm/hooks/useGetForms/types';

import * as Types from './types';
import { actionTypes } from './constants';

export const updateFormsData = (data: IFormConfig[]): Types.IUpdateFormsDataAction => ({
    type: actionTypes.UPDATE_FORMS_DATA,
    payload: data
});
